/**
 * Badge — a small status pill. "20% OFF", "In stock", "Out for delivery".
 *
 * `tone` maps a meaning to a colour so badges stay consistent: success is
 * always the same green everywhere, danger always the same red.
 */

import { cn } from '@/lib/cn';

const TONES = {
  neutral: 'bg-line/70 text-ink',
  primary: 'bg-primary-50 text-primary-700',
  success: 'bg-primary-50 text-primary-700',
  warning: 'bg-accent-50 text-accent-700',
  danger: 'bg-red-50 text-danger',
  accent: 'bg-accent-500 text-ink',
};

export function Badge({ children, tone = 'neutral', className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
